<template>
    <div class='col-12'>
      <meter class='vertical' :value='volume' min='20' max='80' high='50'></meter>
      <span class='db-value'>{{ volume }}dB</span><br>
      <!-- <span class='db-value'>dB</span> -->
    </div>
</template>

<script>
  export default {
    name: 'dbBar',
    props: ["volume"]
    // data: function() {
    //   return {
    //     value: Number,
    //   }
    // },
    // mounted: async function () {
    //   this.value = this.volume;
    // }
  }
</script>

<style>
.vertical {
  transform: rotate(270deg); 
  width: 100px;
  height: 35px;
  position: relative;
  top: 2em;
  right: 2.2em;
}

meter::-webkit-meter-optimum-value {
background: lightblue;
}

meter::-webkit-meter-suboptimum-value {
  background: lightpink;
}

.db-value {
  position: relative;
  top: -4em;
  left: -0.5em;
  font-size: 1.2em;
}

/* meter.vertical::after {
  content: "dB";
  display: block;
  position: relative;
  top: -1.7em;
  left: 3.1em;
  text-align: center;
  font-size: 1.2em;
  transform: rotate(90deg); 
} */

</style>